export default __webpack_public_path__ + "static/media/general_1.92cca91a.png";